export const GET_SUPERVISORS = 'GET_SUPERVISORS';
export const GET_SUPERVISOR_BY_ID = 'GET_SUPERVISOR_BY_ID';
export const UPDATE_SUPERVISOR = 'UPDATE_SUPERVISOR';
export const DELETE_SUPERVISOR = 'DELETE_SUPERVISOR';
export const CREATE_SUPERVISOR = 'CREATE_SUPERVISOR';
